// extracted by mini-css-extract-plugin
export default {"toggle":"ModeToggle_toggle__j2itX","btn":"ModeToggle_btn__tyssx","btnActive":"ModeToggle_btnActive__3hNs2"};